export default __webpack_public_path__ + "static/media/BrandKinder2.1dc1ca22.png";